module.exports = __webpack_public_path__ + "img/ang11.60ecb90f.png";